import { hFetch } from './hFetch';

export const listUserTasks = async () => {
  return await hFetch({ url: '/api/user_tasks' });
};

export const getUserTask = async ({ id }) => {
  return await hFetch({ url: `/api/user_tasks/${id}` });
};

export const updateUserTask = async ({ id, payload }) => {
  return await hFetch({ url: `/api/user_tasks/${id}`, method: 'PATCH', payload });
};
